const getIsSellingPriceProvince=(e,i)=>e&&i?.find((i=>i.name===e))?.showSellingPrice;export default getIsSellingPriceProvince;